import { render, staticRenderFns } from "./ChartTabTemplate.vue?vue&type=template&id=124389d2&scoped=true&"
import script from "./ChartTabTemplate.vue?vue&type=script&lang=js&"
export * from "./ChartTabTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124389d2",
  null
  
)

export default component.exports